export default "__VITE_ASSET__DkcbEzLn__"